import { Link } from 'react-router-dom';

type BrandLogoProps = {
  to?: string;
  inverse?: boolean;
  compactOnMobile?: boolean;
  className?: string;
};

export function BrandLogo({ to, inverse = false, compactOnMobile = false, className = '' }: BrandLogoProps) {
  const image = <picture>
    {compactOnMobile && <source media="(max-width: 420px)" srcSet="/brand/palihog-symbol.png" />}
    <img src={inverse ? '/brand/palihog-logo-white.png' : '/brand/palihog-logo.png'} alt="Palihog" />
  </picture>;
  const classes = ['brand-lockup', compactOnMobile && 'brand-lockup-responsive', className].filter(Boolean).join(' ');

  return to ? <Link className={classes} to={to}>{image}</Link> : <div className={classes}>{image}</div>;
}
